document.documentElement.classList.remove('no-js');

// Schließt das mobile Menü nach einem normalen Navigationsklick.
document.addEventListener('click', function (event) {
  var link = event.target.closest('.mobile-menu__panel a');
  if (!link) return;
  var details = link.closest('details');
  if (details) details.removeAttribute('open');
});

/* ==========================================================================
   VBYC: Zurück-Navigation
   1) Scrollposition wird gespeichert und beim Zurückgehen wiederhergestellt
   2) Seitliche Slider (Kategorien, Marken, Produkte) bleiben an ihrer Stelle
   3) Mobiles Menü (inkl. Tab und Scrollstand im Menü) öffnet sich beim
      Zurückgehen wieder, wenn man es per Klick auf einen Menülink verlassen hat
   ========================================================================== */
(function () {
  var PREFIX = 'vbyc-nav:';
  var store;
  try {
    store = window.sessionStorage;
    store.setItem(PREFIX + 't', '1');
    store.removeItem(PREFIX + 't');
  } catch (e) {
    return;
  }

  var key = PREFIX + location.pathname + location.search;

  function read() {
    try { return JSON.parse(store.getItem(key)) || {}; } catch (e) { return {}; }
  }
  function write(patch) {
    var data = read();
    for (var k in patch) data[k] = patch[k];
    try { store.setItem(key, JSON.stringify(data)); } catch (e) {}
  }
  function currentY() {
    return Math.round(window.pageYOffset || document.documentElement.scrollTop || 0);
  }
  function onReady(fn) {
    if (document.readyState === 'complete') {
      setTimeout(fn, 0);
    } else {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(fn, 0); });
    }
  }

  var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
  var navType = nav ? nav.type : (performance.navigation && performance.navigation.type === 2 ? 'back_forward' : 'navigate');
  var isBack = navType === 'back_forward';
  var isReload = navType === 'reload';
  var saved = read();

  // Normaler Seitenaufruf (Link, Adresse): alten Stand verwerfen
  if (!isBack && !isReload) {
    try { store.removeItem(key); } catch (e) {}
    saved = {};
  }

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  var targetY = (isBack || isReload) && saved.y > 0 ? saved.y : 0;
  var canSave = !targetY;
  var sliderCanSave = !((isBack || isReload) && saved.x && saved.x.length);

  /* ---------- Seitliche Slider finden, speichern, wiederherstellen ---------- */
  function findScrollers() {
    var root = document.getElementById('MainContent') || document.body;
    var all = root.getElementsByTagName('*');
    var counts = {};
    var list = [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.clientWidth === 0 || el.scrollWidth <= el.clientWidth + 1) continue;
      var overflowX = window.getComputedStyle(el).overflowX;
      if (overflowX !== 'auto' && overflowX !== 'scroll') continue;
      var section = el.closest ? el.closest('.shopify-section') : null;
      var cls = typeof el.className === 'string' ? el.className : '';
      var base = (section ? section.id : '') + '|' + cls;
      counts[base] = (counts[base] || 0) + 1;
      list.push({ el: el, key: base + '|' + counts[base] });
    }
    return list;
  }

  function saveSliders() {
    if (!sliderCanSave) return;
    var x = [];
    findScrollers().forEach(function (s) {
      if (s.el.scrollLeft > 1) x.push({ k: s.key, v: Math.round(s.el.scrollLeft) });
    });
    write({ x: x });
  }

  function restoreSliders() {
    if (!(isBack || isReload) || !saved.x || !saved.x.length) return;
    var wanted = {};
    saved.x.forEach(function (entry) { wanted[entry.k] = entry.v; });
    findScrollers().forEach(function (s) {
      var target = wanted[s.key];
      if (target == null || Math.abs(s.el.scrollLeft - target) <= 1) return;
      var oldBehavior = s.el.style.scrollBehavior;
      var oldSnap = s.el.style.scrollSnapType;
      s.el.style.scrollBehavior = 'auto';
      s.el.style.scrollSnapType = 'none';
      s.el.scrollLeft = target;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          s.el.style.scrollBehavior = oldBehavior;
          s.el.style.scrollSnapType = oldSnap;
        });
      });
    });
  }

  if (!sliderCanSave) {
    onReady(restoreSliders);
    window.addEventListener('load', function () {
      restoreSliders();
      setTimeout(function () {
        restoreSliders();
        sliderCanSave = true;
      }, 400);
    });
    setTimeout(function () { sliderCanSave = true; }, 4000);
  }

  /* ---------- Scrollposition speichern ---------- */
  function saveScroll() {
    if (canSave) write({ y: currentY() });
  }
  var scrollTimer;
  window.addEventListener('scroll', function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(saveScroll, 120);
  }, { passive: true });
  window.addEventListener('pagehide', function () {
    saveScroll();
    saveSliders();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      saveScroll();
      saveSliders();
    }
  });

  /* ---------- Scrollposition wiederherstellen ---------- */
  if (targetY) {
    var finished = false;
    var observer = null;
    var interval = null;

    var finish = function () {
      if (finished) return;
      finished = true;
      canSave = true;
      if (observer) observer.disconnect();
      if (interval) clearInterval(interval);
      ['touchstart', 'wheel', 'mousedown', 'keydown'].forEach(function (name) {
        window.removeEventListener(name, finish, true);
      });
    };
    var apply = function () {
      if (finished) return;
      try {
        window.scrollTo({ top: targetY, left: 0, behavior: 'instant' });
      } catch (e) {
        window.scrollTo(0, targetY);
      }
    };

    // Sobald der Nutzer selbst scrollt oder tippt, nicht mehr eingreifen
    ['touchstart', 'wheel', 'mousedown', 'keydown'].forEach(function (name) {
      window.addEventListener(name, finish, { capture: true, passive: true });
    });

    apply();
    if ('ResizeObserver' in window) {
      // Seite wird durch nachladende Bilder höher: Position jedes Mal neu setzen
      observer = new ResizeObserver(apply);
      observer.observe(document.documentElement);
    } else {
      interval = setInterval(apply, 120);
    }
    window.addEventListener('load', function () {
      apply();
      setTimeout(finish, 700);
    });
    setTimeout(finish, 4000);
  }

  /* ---------- Klicks: Slider-Stand und mobiles Menü merken ---------- */
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    // Jeder Link: Stand der seitlichen Slider sichern
    if (event.target.closest('a[href]')) saveSliders();

    // Link im Menü: offenen Zustand, Tab und Menü-Scroll merken
    var link = event.target.closest('[data-vbyc-mm] a[href]');
    if (!link) return;
    var activeTab = document.querySelector('[data-vbyc-mm-tab][aria-selected="true"]');
    var panel = document.querySelector('[data-vbyc-mm]');
    var patch = {
      menu: 1,
      tab: activeTab ? activeTab.getAttribute('data-vbyc-mm-tab') : 'cat',
      mmY: panel ? Math.round(panel.scrollTop) : 0
    };
    if (canSave) patch.y = currentY();
    write(patch);
  }, true);

  /* ---------- Mobiles Menü wieder öffnen ---------- */
  onReady(function () {
    var details = document.querySelector('[data-mobile-menu]');
    if (!details) return;

    // Menü bewusst geschlossen: Merker löschen
    details.addEventListener('toggle', function () {
      if (!details.open) write({ menu: 0 });
    });

    if (!isBack || !saved.menu) return;

    if (saved.tab) {
      var tab = document.querySelector('[data-vbyc-mm-tab="' + saved.tab + '"]');
      if (tab) tab.click();
    }
    details.open = true;

    // Scrollstand im Menü wiederherstellen (Menü baut sich kurz noch um)
    var cancelled = false;
    var stop = function () { cancelled = true; };
    var panel = document.querySelector('[data-vbyc-mm]');
    if (panel) panel.addEventListener('touchstart', stop, { once: true, passive: true });
    var attempts = 0;
    (function setMenuScroll() {
      if (cancelled || !panel || !saved.mmY) return;
      panel.scrollTop = saved.mmY;
      if (++attempts < 8) setTimeout(setMenuScroll, 80);
    })();
  });
})();
